"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceHeader = class UcInvoiceHeader extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    formId;
    onForm_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formId");
    }
    invoiceNumber;
    onInvoice_number(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoiceNumber");
    }
    formContext;
    onForm_context(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("formContext");
    }
    messages;
    ux;
    dataMembers = ['messages', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                messages: {
                    newTransaction: this.$fn.pgettext("Invoice", "New Invoice"),
                    invoiceKind: {
                        incoming: this.$fn.pgettext("InvoiceKind", "Incoming Invoice"),
                        outgoing: this.$fn.pgettext("InvoiceKind", "Outgoing Invoice"),
                    },
                    createCorrectorTooltip: this.$fn.pgettext("Invoice", "Create corrector invoice"),
                    createStornoTooltip: this.$fn.pgettext("Invoice", "Create storno invoice"),
                    createPassThroughTooltip: this.$fn.pgettext("Invoice|Tooltip", "Rebilling the line items to a designated client."),
                    createAdvanceInvoiceTooltip: this.$fn.pgettext("Invoice|Tooltip", "Create advance invoice from a Pro Forma invoice."),
                    createFinalInvoiceTooltip: this.$fn.pgettext("Invoice|Tooltip", "Create final invoice from a Pro Forma or advance invoice."),
                },
                ux: null,
            },
        };
    }
    get resourceTitle() {
        if (this.loaded) {
            return this.messages.invoiceKind[this.invoice.invoice_kind];
        }
        return null;
    }
    get resourceKey() {
        if (this.loaded) {
            return this.invoiceNumber || (this.invoice.isNew ? this.messages.newTransaction : this.invoice.invoice_number);
        }
        return null;
    }
    get createCorrectorTooltip() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.modifiable.message') || this.messages.createCorrectorTooltip;
        }
        return null;
    }
    get createStornoTooltip() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.reversible.message') || this.messages.createStornoTooltip;
        }
        return null;
    }
    get invoiceIsReversible() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.reversible.result');
        }
        return null;
    }
    get invoiceIsModifiable() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.modifiable.result');
        }
        return null;
    }
    get invoiceIsRegistrable() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.registrable.result');
        }
        return null;
    }
    get invoicePassThroughIsEnabled() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.pass_through_enabled') === true ||
                _.get(this.invoice, 'meta.pass_through_enabled.result');
        }
        return null;
    }
    get canCreateAdvanceInvoice() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.can_create_advance_invoice') === true;
        }
        return null;
    }
    get canCreateFinalInvoice() {
        if (this.loaded) {
            return _.get(this.invoice, 'meta.can_create_final_invoice') === true;
        }
        return null;
    }
    async act_3573211234170528_emit_7296_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_3573211234170528_success(event, scope) {
        return await this.actions.evh_3573211234170528_success.executeFromDOM(this, event, scope);
    }
    async act_3350181908999980_emit_7298_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_3350181908999980_success(event, scope) {
        return await this.actions.evh_3350181908999980_success.executeFromDOM(this, event, scope);
    }
    async act_5626515103939381_emit_7300_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_5626515103939381_success(event, scope) {
        return await this.actions.evh_5626515103939381_success.executeFromDOM(this, event, scope);
    }
    async act_5072463219534047_emit_7302_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_5072463219534047_success(event, scope) {
        return await this.actions.evh_5072463219534047_success.executeFromDOM(this, event, scope);
    }
    async act_5450657804282831_emit_7306_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_5450657804282831_close_7305_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_5450657804282831_showModal_7304_getActionArgs($event) {
        return {
            name: "InvoiceEditor",
            props: {
                invoice: _.cloneDeep(this.invoice),
            },
        };
    }
    async evh_5450657804282831_clickPreventStop(event, scope) {
        return await this.actions.evh_5450657804282831_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_995920279152457_emit_7308_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_995920279152457_clickPreventStop(event, scope) {
        return await this.actions.evh_995920279152457_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_8434031504612555_emit_7310_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_8434031504612555_clickPreventStop(event, scope) {
        return await this.actions.evh_8434031504612555_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_1246756660686207_showModal_7312_getActionArgs($event) {
        return {
            name: "InvoiceLogMessageViewer",
            props: {
                invoiceId: this.invoice.id,
            },
        };
    }
    async evh_1246756660686207_clickPreventStop(event, scope) {
        return await this.actions.evh_1246756660686207_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_932298791746317_emit_7316_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_932298791746317_close_7315_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_932298791746317_showModal_7314_getActionArgs($event) {
        return {
            name: "RegisterEntry",
            props: {
                invoice: this.invoice,
            },
        };
    }
    async evh_932298791746317_click(event, scope) {
        return await this.actions.evh_932298791746317_click.executeFromDOM(this, event, scope);
    }
    async act_2674698048827991_emit_7320_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_2674698048827991_request_7318_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: { invoice_id: this.invoice.id, invoice_type: 'copy' },
        };
    }
    async evh_2674698048827991_click(event, scope) {
        return await this.actions.evh_2674698048827991_click.executeFromDOM(this, event, scope);
    }
    async act_2252498968068653_emit_7324_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_2252498968068653_close_7323_getWhen($event) {
        return $event.data.modalResult.ok;
    }
    async act_2252498968068653_showModal_7322_getActionArgs($event) {
        return {
            name: "CreatePassThroughInvoice",
            props: {
                invoice: this.invoice,
            },
        };
    }
    async evh_2252498968068653_click(event, scope) {
        return await this.actions.evh_2252498968068653_click.executeFromDOM(this, event, scope);
    }
    async act_3512640571721973_emit_7328_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_3512640571721973_request_7326_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: { invoice_id: this.invoice.id, invoice_type: 'advance' },
        };
    }
    async evh_3512640571721973_click(event, scope) {
        return await this.actions.evh_3512640571721973_click.executeFromDOM(this, event, scope);
    }
    async act_6424219584985303_emit_7332_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_6424219584985303_request_7330_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: { invoice_id: this.invoice.id, invoice_type: 'final' },
        };
    }
    async evh_6424219584985303_click(event, scope) {
        return await this.actions.evh_6424219584985303_click.executeFromDOM(this, event, scope);
    }
    async act_6886333622481462_emit_7336_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_6886333622481462_request_7334_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: { invoice_id: this.invoice.id, invoice_type: 'storno' },
        };
    }
    async evh_6886333622481462_click(event, scope) {
        return await this.actions.evh_6886333622481462_click.executeFromDOM(this, event, scope);
    }
    async act_6074864154397733_emit_7340_getActionArgs($event) {
        return {
            event: "created",
            value: $event.data.response.data,
        };
    }
    async act_6074864154397733_request_7338_getActionArgs($event) {
        return {
            operation: "create_invoice",
            data: {
                invoice_id: this.invoice.id,
                invoice_type: 'correction',
                invoice_lines: _.map(this.formContext.selectedInvoiceLines, p => p.id).join(',')
            },
        };
    }
    async evh_6074864154397733_click(event, scope) {
        return await this.actions.evh_6074864154397733_click.executeFromDOM(this, event, scope);
    }
    async act_8797352275194556_emit_7342_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_8797352275194556_success(event, scope) {
        return await this.actions.evh_8797352275194556_success.executeFromDOM(this, event, scope);
    }
    async act_6679522740328543_emit_7344_getActionArgs($event) {
        return {
            event: "deleted",
        };
    }
    async evh_6679522740328543_success(event, scope) {
        return await this.actions.evh_6679522740328543_success.executeFromDOM(this, event, scope);
    }
    async act_4848747000340100_showModal_7346_getActionArgs($event) {
        return {
            name: "entityEvents",
            props: {
                entityId: this.invoice.id,
            },
        };
    }
    async evh_4848747000340100_clickPreventStop(event, scope) {
        return await this.actions.evh_4848747000340100_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_3573211234170528_emit_7296 = new core_1.actions.EmitAction({
            actionArgs: this.act_3573211234170528_emit_7296_getActionArgs,
            events: [],
        });
        const evh_3573211234170528_success_7295 = new core_1.actions.EventHandlerImpl({
            action: act_3573211234170528_emit_7296,
            event: "success",
            displayName: "emit",
        });
        const evh_3573211234170528_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3573211234170528_success_7295],
        });
        const act_3350181908999980_emit_7298 = new core_1.actions.EmitAction({
            actionArgs: this.act_3350181908999980_emit_7298_getActionArgs,
            events: [],
        });
        const evh_3350181908999980_success_7297 = new core_1.actions.EventHandlerImpl({
            action: act_3350181908999980_emit_7298,
            event: "success",
            displayName: "emit",
        });
        const evh_3350181908999980_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3350181908999980_success_7297],
        });
        const act_5626515103939381_emit_7300 = new core_1.actions.EmitAction({
            actionArgs: this.act_5626515103939381_emit_7300_getActionArgs,
            events: [],
        });
        const evh_5626515103939381_success_7299 = new core_1.actions.EventHandlerImpl({
            action: act_5626515103939381_emit_7300,
            event: "success",
            displayName: "emit",
        });
        const evh_5626515103939381_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5626515103939381_success_7299],
        });
        const act_5072463219534047_emit_7302 = new core_1.actions.EmitAction({
            actionArgs: this.act_5072463219534047_emit_7302_getActionArgs,
            events: [],
        });
        const evh_5072463219534047_success_7301 = new core_1.actions.EventHandlerImpl({
            action: act_5072463219534047_emit_7302,
            event: "success",
            displayName: "emit",
        });
        const evh_5072463219534047_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5072463219534047_success_7301],
        });
        const act_5450657804282831_emit_7306 = new core_1.actions.EmitAction({
            actionArgs: this.act_5450657804282831_emit_7306_getActionArgs,
            events: [],
        });
        const evh_5450657804282831_close_7305 = new core_1.actions.EventHandlerImpl({
            action: act_5450657804282831_emit_7306,
            event: "close",
            when: this.evh_5450657804282831_close_7305_getWhen,
            displayName: "emit",
        });
        const act_5450657804282831_showModal_7304 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_5450657804282831_showModal_7304_getActionArgs,
            events: [evh_5450657804282831_close_7305],
        });
        const evh_5450657804282831_clickPreventStop_7303 = new core_1.actions.EventHandlerImpl({
            action: act_5450657804282831_showModal_7304,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_5450657804282831_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_5450657804282831_clickPreventStop_7303],
        });
        const act_995920279152457_emit_7308 = new core_1.actions.EmitAction({
            actionArgs: this.act_995920279152457_emit_7308_getActionArgs,
            displayName: "reload",
            events: [],
        });
        const evh_995920279152457_clickPreventStop_7307 = new core_1.actions.EventHandlerImpl({
            action: act_995920279152457_emit_7308,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_995920279152457_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_995920279152457_clickPreventStop_7307],
        });
        const act_8434031504612555_emit_7310 = new core_1.actions.EmitAction({
            actionArgs: this.act_8434031504612555_emit_7310_getActionArgs,
            displayName: "reload",
            events: [],
        });
        const evh_8434031504612555_clickPreventStop_7309 = new core_1.actions.EventHandlerImpl({
            action: act_8434031504612555_emit_7310,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_8434031504612555_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8434031504612555_clickPreventStop_7309],
        });
        const act_1246756660686207_showModal_7312 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_1246756660686207_showModal_7312_getActionArgs,
            events: [],
        });
        const evh_1246756660686207_clickPreventStop_7311 = new core_1.actions.EventHandlerImpl({
            action: act_1246756660686207_showModal_7312,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_1246756660686207_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1246756660686207_clickPreventStop_7311],
        });
        const act_932298791746317_emit_7316 = new core_1.actions.EmitAction({
            actionArgs: this.act_932298791746317_emit_7316_getActionArgs,
            events: [],
        });
        const evh_932298791746317_close_7315 = new core_1.actions.EventHandlerImpl({
            action: act_932298791746317_emit_7316,
            event: "close",
            when: this.evh_932298791746317_close_7315_getWhen,
            displayName: "emit",
        });
        const act_932298791746317_showModal_7314 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_932298791746317_showModal_7314_getActionArgs,
            displayName: "registerInvoice",
            events: [evh_932298791746317_close_7315],
        });
        const evh_932298791746317_click_7313 = new core_1.actions.EventHandlerImpl({
            action: act_932298791746317_showModal_7314,
            event: "click",
            displayName: "registerInvoice",
        });
        const evh_932298791746317_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_932298791746317_click_7313],
        });
        const act_2674698048827991_emit_7320 = new core_1.actions.EmitAction({
            actionArgs: this.act_2674698048827991_emit_7320_getActionArgs,
            events: [],
        });
        const evh_2674698048827991_success_7319 = new core_1.actions.EventHandlerImpl({
            action: act_2674698048827991_emit_7320,
            event: "success",
            displayName: "emit",
        });
        const act_2674698048827991_request_7318 = new core_1.actions.RequestAction({
            actionArgs: this.act_2674698048827991_request_7318_getActionArgs,
            displayName: "createInvoicecopy",
            events: [evh_2674698048827991_success_7319],
        });
        const evh_2674698048827991_click_7317 = new core_1.actions.EventHandlerImpl({
            action: act_2674698048827991_request_7318,
            event: "click",
            displayName: "createInvoicecopy",
        });
        const evh_2674698048827991_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2674698048827991_click_7317],
        });
        const act_2252498968068653_emit_7324 = new core_1.actions.EmitAction({
            actionArgs: this.act_2252498968068653_emit_7324_getActionArgs,
            events: [],
        });
        const evh_2252498968068653_close_7323 = new core_1.actions.EventHandlerImpl({
            action: act_2252498968068653_emit_7324,
            event: "close",
            when: this.evh_2252498968068653_close_7323_getWhen,
            displayName: "emit",
        });
        const act_2252498968068653_showModal_7322 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2252498968068653_showModal_7322_getActionArgs,
            displayName: "createPassThroughInvoice",
            events: [evh_2252498968068653_close_7323],
        });
        const evh_2252498968068653_click_7321 = new core_1.actions.EventHandlerImpl({
            action: act_2252498968068653_showModal_7322,
            event: "click",
            displayName: "createPassThroughInvoice",
        });
        const evh_2252498968068653_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2252498968068653_click_7321],
        });
        const act_3512640571721973_emit_7328 = new core_1.actions.EmitAction({
            actionArgs: this.act_3512640571721973_emit_7328_getActionArgs,
            events: [],
        });
        const evh_3512640571721973_success_7327 = new core_1.actions.EventHandlerImpl({
            action: act_3512640571721973_emit_7328,
            event: "success",
            displayName: "emit",
        });
        const act_3512640571721973_request_7326 = new core_1.actions.RequestAction({
            actionArgs: this.act_3512640571721973_request_7326_getActionArgs,
            displayName: "createAdvanceInvoice",
            events: [evh_3512640571721973_success_7327],
        });
        const evh_3512640571721973_click_7325 = new core_1.actions.EventHandlerImpl({
            action: act_3512640571721973_request_7326,
            event: "click",
            displayName: "createAdvanceInvoice",
        });
        const evh_3512640571721973_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3512640571721973_click_7325],
        });
        const act_6424219584985303_emit_7332 = new core_1.actions.EmitAction({
            actionArgs: this.act_6424219584985303_emit_7332_getActionArgs,
            events: [],
        });
        const evh_6424219584985303_success_7331 = new core_1.actions.EventHandlerImpl({
            action: act_6424219584985303_emit_7332,
            event: "success",
            displayName: "emit",
        });
        const act_6424219584985303_request_7330 = new core_1.actions.RequestAction({
            actionArgs: this.act_6424219584985303_request_7330_getActionArgs,
            displayName: "createFinalInvoice",
            events: [evh_6424219584985303_success_7331],
        });
        const evh_6424219584985303_click_7329 = new core_1.actions.EventHandlerImpl({
            action: act_6424219584985303_request_7330,
            event: "click",
            displayName: "createFinalInvoice",
        });
        const evh_6424219584985303_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6424219584985303_click_7329],
        });
        const act_6886333622481462_emit_7336 = new core_1.actions.EmitAction({
            actionArgs: this.act_6886333622481462_emit_7336_getActionArgs,
            events: [],
        });
        const evh_6886333622481462_success_7335 = new core_1.actions.EventHandlerImpl({
            action: act_6886333622481462_emit_7336,
            event: "success",
            displayName: "emit",
        });
        const act_6886333622481462_request_7334 = new core_1.actions.RequestAction({
            actionArgs: this.act_6886333622481462_request_7334_getActionArgs,
            displayName: "createStornoInvoice",
            events: [evh_6886333622481462_success_7335],
        });
        const evh_6886333622481462_click_7333 = new core_1.actions.EventHandlerImpl({
            action: act_6886333622481462_request_7334,
            event: "click",
            displayName: "createStornoInvoice",
        });
        const evh_6886333622481462_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6886333622481462_click_7333],
        });
        const act_6074864154397733_emit_7340 = new core_1.actions.EmitAction({
            actionArgs: this.act_6074864154397733_emit_7340_getActionArgs,
            events: [],
        });
        const evh_6074864154397733_success_7339 = new core_1.actions.EventHandlerImpl({
            action: act_6074864154397733_emit_7340,
            event: "success",
            displayName: "emit",
        });
        const act_6074864154397733_request_7338 = new core_1.actions.RequestAction({
            actionArgs: this.act_6074864154397733_request_7338_getActionArgs,
            displayName: "createCorrectorIvoice",
            events: [evh_6074864154397733_success_7339],
        });
        const evh_6074864154397733_click_7337 = new core_1.actions.EventHandlerImpl({
            action: act_6074864154397733_request_7338,
            event: "click",
            displayName: "createCorrectorIvoice",
        });
        const evh_6074864154397733_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6074864154397733_click_7337],
        });
        const act_8797352275194556_emit_7342 = new core_1.actions.EmitAction({
            actionArgs: this.act_8797352275194556_emit_7342_getActionArgs,
            events: [],
        });
        const evh_8797352275194556_success_7341 = new core_1.actions.EventHandlerImpl({
            action: act_8797352275194556_emit_7342,
            event: "success",
            displayName: "emit",
        });
        const evh_8797352275194556_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8797352275194556_success_7341],
        });
        const act_6679522740328543_emit_7344 = new core_1.actions.EmitAction({
            actionArgs: this.act_6679522740328543_emit_7344_getActionArgs,
            events: [],
        });
        const evh_6679522740328543_success_7343 = new core_1.actions.EventHandlerImpl({
            action: act_6679522740328543_emit_7344,
            event: "success",
            displayName: "emit",
        });
        const evh_6679522740328543_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6679522740328543_success_7343],
        });
        const act_4848747000340100_showModal_7346 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_4848747000340100_showModal_7346_getActionArgs,
            events: [],
        });
        const evh_4848747000340100_clickPreventStop_7345 = new core_1.actions.EventHandlerImpl({
            action: act_4848747000340100_showModal_7346,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_4848747000340100_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4848747000340100_clickPreventStop_7345],
        });
        return {
            act_3573211234170528_emit_7296,
            evh_3573211234170528_success_7295,
            evh_3573211234170528_success,
            act_3350181908999980_emit_7298,
            evh_3350181908999980_success_7297,
            evh_3350181908999980_success,
            act_5626515103939381_emit_7300,
            evh_5626515103939381_success_7299,
            evh_5626515103939381_success,
            act_5072463219534047_emit_7302,
            evh_5072463219534047_success_7301,
            evh_5072463219534047_success,
            act_5450657804282831_emit_7306,
            evh_5450657804282831_close_7305,
            act_5450657804282831_showModal_7304,
            evh_5450657804282831_clickPreventStop_7303,
            evh_5450657804282831_clickPreventStop,
            act_995920279152457_emit_7308,
            evh_995920279152457_clickPreventStop_7307,
            evh_995920279152457_clickPreventStop,
            act_8434031504612555_emit_7310,
            evh_8434031504612555_clickPreventStop_7309,
            evh_8434031504612555_clickPreventStop,
            act_1246756660686207_showModal_7312,
            evh_1246756660686207_clickPreventStop_7311,
            evh_1246756660686207_clickPreventStop,
            act_932298791746317_emit_7316,
            evh_932298791746317_close_7315,
            act_932298791746317_showModal_7314,
            evh_932298791746317_click_7313,
            evh_932298791746317_click,
            act_2674698048827991_emit_7320,
            evh_2674698048827991_success_7319,
            act_2674698048827991_request_7318,
            evh_2674698048827991_click_7317,
            evh_2674698048827991_click,
            act_2252498968068653_emit_7324,
            evh_2252498968068653_close_7323,
            act_2252498968068653_showModal_7322,
            evh_2252498968068653_click_7321,
            evh_2252498968068653_click,
            act_3512640571721973_emit_7328,
            evh_3512640571721973_success_7327,
            act_3512640571721973_request_7326,
            evh_3512640571721973_click_7325,
            evh_3512640571721973_click,
            act_6424219584985303_emit_7332,
            evh_6424219584985303_success_7331,
            act_6424219584985303_request_7330,
            evh_6424219584985303_click_7329,
            evh_6424219584985303_click,
            act_6886333622481462_emit_7336,
            evh_6886333622481462_success_7335,
            act_6886333622481462_request_7334,
            evh_6886333622481462_click_7333,
            evh_6886333622481462_click,
            act_6074864154397733_emit_7340,
            evh_6074864154397733_success_7339,
            act_6074864154397733_request_7338,
            evh_6074864154397733_click_7337,
            evh_6074864154397733_click,
            act_8797352275194556_emit_7342,
            evh_8797352275194556_success_7341,
            evh_8797352275194556_success,
            act_6679522740328543_emit_7344,
            evh_6679522740328543_success_7343,
            evh_6679522740328543_success,
            act_4848747000340100_showModal_7346,
            evh_4848747000340100_clickPreventStop_7345,
            evh_4848747000340100_clickPreventStop,
            reload: act_8434031504612555_emit_7310,
            registerInvoice: act_932298791746317_showModal_7314,
            createInvoicecopy: act_2674698048827991_request_7318,
            createPassThroughInvoice: act_2252498968068653_showModal_7322,
            createAdvanceInvoice: act_3512640571721973_request_7326,
            createFinalInvoice: act_6424219584985303_request_7330,
            createStornoInvoice: act_6886333622481462_request_7334,
            createCorrectorIvoice: act_6074864154397733_request_7338,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceHeader.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceHeader.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: function () {
            return this.$fn.randomElementId();
        },
    }),
    __metadata("design:type", String)
], UcInvoiceHeader.prototype, "formId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceHeader.prototype, "onForm_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], UcInvoiceHeader.prototype, "invoiceNumber", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoiceNumber'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceHeader.prototype, "onInvoice_number", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceHeader.prototype, "formContext", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('formContext'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceHeader.prototype, "onForm_context", null);
UcInvoiceHeader = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceHeader);
exports.default = UcInvoiceHeader;
vue_property_decorator_1.Vue.component("UcInvoiceHeader", UcInvoiceHeader);
